/*
 * Fitment-aware PDP recommendations strip (sections/ymm-related.liquid).
 *
 * Product has fitment -> "More parts for your {1994-1998 Porsche 911}": Storefront
 *   search filtered on this PRODUCT's applications (one exact mmy triple per
 *   application, OR'd), minus this product and its own category — the strip shows
 *   the REST of the restoration for the same vehicle, not near-duplicates of
 *   what's already on screen.
 * No fitment / thin matches -> "Our Best Sellers": BEST_SELLING sort with Free
 *   Samples excluded ($0 swatch products are the store's top "sellers" by unit
 *   count and would otherwise fill the strip).
 */
(function () {
  var TOKEN = "d3021029f8d76cfe263c16528e4fb3b3"; // public storefront token (read-only)
  var ENDPOINT = "/api/2024-07/graphql.json";
  var FRAG = "title handle productType featuredImage{url} priceRange{minVariantPrice{amount}}";
  var SHOW = 12; // scrollable row — arrows page through, ~4 visible at a time
  var MAX_APPS = 3; // one representative triple per application, capped

  var root = document.querySelector("[data-ymm-related]");
  if (!root) return;
  var curHandle = root.getAttribute("data-cur-handle");
  var curType = root.getAttribute("data-cur-type");
  var titleEl = root.querySelector("[data-ymm-related-title]");
  var allEl = root.querySelector("[data-ymm-related-all]");
  var grid = root.querySelector("[data-ymm-related-grid]");

  // "Make|Model|1994-1998" -> {make, model, y0, y1, mid}
  function parseApp(app) {
    var p = String(app).split("|");
    if (p.length !== 3) return null;
    var yr = p[2].split("-");
    var y0 = parseInt(yr[0], 10), y1 = parseInt(yr[1] || yr[0], 10);
    if (!p[0] || !p[1] || isNaN(y0) || isNaN(y1)) return null;
    return { make: p[0], model: p[1], y0: y0, y1: y1, mid: Math.round((y0 + y1) / 2) };
  }
  function apps() {
    try {
      var a = JSON.parse(root.getAttribute("data-apps") || "null");
      if (!Array.isArray(a)) return [];
      return a.map(parseApp).filter(Boolean);
    } catch (e) { return []; }
  }

  function gql(query) {
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": TOKEN },
      body: JSON.stringify({ query: query }),
    }).then(function (r) { return r.json(); });
  }
  var esc = NewarkYMM.esc;
  function money(a) {
    var n = parseFloat(a);
    if (isNaN(n)) return "";
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function card(p) {
    var img = "";
    if (p.featuredImage && p.featuredImage.url) {
      var u = p.featuredImage.url + (p.featuredImage.url.indexOf("?") > -1 ? "&" : "?") + "width=480";
      img = '<img src="' + esc(u) + '" alt="' + esc(p.title) + '" loading="lazy">';
    }
    return '<a class="ymm-related__card" href="/products/' + esc(p.handle) + '">' +
      '<div class="ymm-related__img">' + img + "</div>" +
      '<p class="ymm-related__ptitle">' + esc(p.title) + "</p>" +
      '<p class="ymm-related__price">From ' + money(p.priceRange.minVariantPrice.amount) + "</p></a>";
  }
  function usable(p) {
    return p && p.handle !== curHandle && p.productType !== "Free Samples" &&
      parseFloat(p.priceRange.minVariantPrice.amount) > 0;
  }

  // Curated complementary products (S&D metafield) always lead the strip —
  // the accessories that complete THIS purchase (adhesive, padding, …).
  var compItems = [];
  function fetchComplementary() {
    var handles;
    try {
      handles = JSON.parse(root.getAttribute("data-complementary") || "[]");
    } catch (e) { handles = []; }
    if (!Array.isArray(handles) || !handles.length) return Promise.resolve();
    var q = "{ " + handles.slice(0, 5).map(function (h, i) {
      return "c" + i + ": product(handle:" + JSON.stringify(String(h)) + "){ " + FRAG + " }";
    }).join(" ") + " }";
    return gql(q).then(function (res) {
      var d = res.data || {};
      compItems = handles.slice(0, 5)
        .map(function (_, i) { return d["c" + i]; })
        .filter(usable);
    }).catch(function () { /* strip works without them */ });
  }

  function show(items, title, allHref, allLabel) {
    items = compItems.concat(items.filter(function (p) {
      return !compItems.some(function (c) { return c.handle === p.handle; });
    }));
    if (items.length < 2) return false;
    grid.innerHTML = items.slice(0, SHOW).map(card).join("");
    titleEl.textContent = title;
    if (allHref) { allEl.href = allHref; allEl.textContent = allLabel + " →"; allEl.hidden = false; }
    else { allEl.hidden = true; }
    root.hidden = false;
    wireArrows();
    return true;
  }
  function wireArrows() {
    var prev = root.querySelector("[data-ymm-related-prev]");
    var next = root.querySelector("[data-ymm-related-next]");
    function sync() {
      var overflow = grid.scrollWidth > grid.clientWidth + 4;
      prev.hidden = next.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = grid.scrollLeft <= 4;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4;
    }
    function page(dir) { grid.scrollBy({ left: dir * grid.clientWidth * 0.9, behavior: "smooth" }); }
    prev.onclick = function () { page(-1); };
    next.onclick = function () { page(1); };
    grid.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  function fitmentStrip(list) {
    // One mid-range triple per application; same-key productFilters are OR'd.
    var filters = list.slice(0, MAX_APPS).map(function (a) {
      var mmy = a.make + "|" + a.model + "|" + a.mid;
      return '{productMetafield:{namespace:"filters",key:"mmy",value:' + JSON.stringify(mmy) + "}}";
    }).join(",");
    var q = '{ search(first:16, query:"", types:PRODUCT, productFilters:[' + filters +
      "]) { nodes { ... on Product { " + FRAG + " } } } }";
    return gql(q).then(function (res) {
      var items = (((res.data || {}).search || {}).nodes || []).filter(usable)
        .filter(function (p) { return p.productType !== curType; }); // rest of the restoration
      var a = list[0];
      var years = a.y0 === a.y1 ? String(a.y0) : a.y0 + "-" + a.y1;
      // Escape link: make + one exact mmy triple per year of this application's
      // window (same-key URL filters are OR'd). A model param would exclude
      // multi-application products (their single-type model field stays blank);
      // the window matches the strip title, so no invented single year.
      return show(items, "More parts for your " + years + " " + a.make + " " + a.model,
        NewarkYMM.searchUrl({ make: a.make, model: a.model }, { years: [a.y0, a.y1] }), "See all " + a.make + " " + a.model + " parts");
    });
  }
  function bestSellers() {
    var q = '{ products(first:20, sortKey:BEST_SELLING, query:"-product_type:\'Free Samples\'") { nodes { ' + FRAG + " } } }";
    return gql(q).then(function (res) {
      var items = (((res.data || {}).products || {}).nodes || []).filter(usable);
      show(items, "Our Best Sellers", null);
    });
  }

  fetchComplementary().then(function () {
    var list = apps();
    if (list.length) {
      return fitmentStrip(list).then(function (ok) { if (!ok) return bestSellers(); })
        .catch(function () { return bestSellers(); });
    }
    return bestSellers();
  });
})();
